export default {
      id: "top-shape2-usage",
      viewBox: "0 0 1821 248",
      url: "../../assets/" + "sprite.svg#top-shape2-usage",
      toString: function () {
        return this.url;
      }
    }